<form (ngSubmit)="onSubmit()" [formGroup]="formService">
  <p-dialog header="Crear Servicio" [modal]="true" [maximizable]="true" [(visible)]="visible"
    [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }" [style]="{ width: '50vw' }" (onHide)="closeDialog()">
    <div class="flex flex-column gap-4 mt-3">
      <!-- Sección Selección de Cliente (si no es presupuesto) -->
      @if(!isBudget()) {
      <div>
        <div class="text-900 font-bold text-xl mb-3 flex align-items-center gap-2">
          <i class="pi pi-user-plus text-primary"></i> Selección de Cliente
        </div>
        <div class="field">
          <app-client-selector (clientSelected)="onClientSelected($event)" [dialogVisible]="visible" />
        </div>
      </div>
      <p-divider></p-divider>
      }

      <!-- Sección Información de Contacto -->
      <div>
        <div class="text-900 font-bold text-xl mb-3 flex align-items-center gap-2">
          <i class="pi pi-id-card text-primary"></i> Información de Contacto
        </div>
        <div class="formgrid grid">
          <div class="col-12 md:col-6">
            <app-input label="Nombre" formControlName="name" name="name" type="name" />
          </div>
          <div class="col-12 md:col-6">
            <app-input label="Email" formControlName="email" name="email" type="email" />
          </div>
          <div class="col-12 md:col-6">
            <app-input label="Teléfono" formControlName="phone" name="phone" type="number" />
          </div>
          <div class="col-12 md:col-6">
            <app-input label="Teléfono (opc.)" formControlName="phone_optional" name="phone_optional" type="number" />
          </div>
        </div>
      </div>

      <p-divider></p-divider>

      <!-- Sección Ubicación -->
      <div>
        <div class="text-900 font-bold text-xl mb-3 flex align-items-center gap-2">
          <i class="pi pi-map-marker text-primary"></i> Ubicación
        </div>
        <div class="formgrid grid">
          <div class="col-12 md:col-6">
            <app-input label="Provincia" formControlName="province" name="province" />
          </div>
          <div class="col-12 md:col-6">
            <app-input label="Población" formControlName="city" name="city" />
          </div>
          <div class="col-12 md:col-8">
            <app-input label="Dirección" formControlName="address" name="address" />
          </div>
          <div class="col-12 md:col-4">
            <app-input label="Código Postal" formControlName="postal_code" name="postal_code" type="number-length"
              [minLength]="5" [customErrorMessages]="{ minlength: 'Mínimo 5 caracteres' }" />
          </div>
        </div>
      </div>

      <p-divider></p-divider>

      <!-- Sección Detalles del Servicio -->
      <div>
        <div class="text-900 font-bold text-xl mb-3 flex align-items-center gap-2">
          <i class="pi pi-briefcase text-primary"></i> Detalles del Servicio
        </div>
        <div class="formgrid grid">
          <div class="col-12 md:col-6">
            <app-input label="NIF/CIF" formControlName="nif_cif" name="nif_cif" />
          </div>
          <div class="col-12 md:col-6">
            <div class="field">
              <label class="font-semibold block mb-2">Fecha de inicio</label>
              <p-calendar name="startAt" formControlName="startAt" [style]="{ width: '100%' }" appendTo="body"
                [showIcon]="true" [showTime]="true" dateFormat="dd/mm/yy" />
            </div>
          </div>
          <div class="col-12 md:col-6">
            <app-employee-selector [dialogVisible]="visible" (employeeSelected)="onEmployeeSelected($event)" />
          </div>
          @if(isAdmin()){
          <div class="col-12 md:col-6">
            <div class="field">
              <label class="font-semibold block mb-2">Importe</label>
              <p-inputNumber name="import" [style]="{ width: '100%' }" formControlName="import" mode="currency"
                currency="EUR" locale="es-ES" />
            </div>
          </div>
          }
          <div class="col-12">
            <div class="field">
              <label class="font-semibold block mb-2">Descripción</label>
              <textarea pInputTextarea class="w-full" rows="4" formControlName="description"
                placeholder="Descripción del trabajo..."></textarea>
            </div>
          </div>
        </div>
      </div>

      <p-divider></p-divider>

      <!-- Sección Archivos / Adjuntos -->
      <div>
        <div class="text-900 font-bold text-xl mb-3 flex align-items-center gap-2">
          <i class="pi pi-cloud-upload text-primary"></i> Documentación y Archivos
        </div>
        @if (isBudget()) {
        <app-media-viewer [mediaFiles]="mediaFiles()" [actionDisabled]="true" />
        } @else {
        <app-upload (filesSelected)="onFilesSelected($event)" />
        }
      </div>
    </div>

    <ng-template pTemplate="footer">
      <div class="flex justify-content-end gap-2 mt-3">
        <p-button label="Cancelar" severity="secondary" icon="pi pi-times" (onClick)="closeDialog()"
          [outlined]="true" />
        <p-button label="Guardar Servicio" type="submit" icon="pi pi-check" [disabled]="formService.invalid" />
      </div>
    </ng-template>
  </p-dialog>
</form>